import moment from "moment";

export default function getArrivalDateLabel(
  vendorOption: VendorOptionState | null | undefined,
  format = "ddd, MMM D",
): string | null {
  if (!vendorOption?.arrivalDate || vendorOption.isBackordered === true || vendorOption.shippingTime >= 30) {
    return null;
  }
  const arrivalDate = moment(vendorOption.arrivalDate, "YYYY-MM-DD", true);
  return arrivalDate.isValid() ? arrivalDate.format(format) : null;
}
